module.exports = __webpack_public_path__ + "static/media/image.104fd14b.png";